export class Estacao{
    id: string;
    animals: string[];
    devices: string[];
    lastData: string;
}